import createPage from "@src/components/page"
import React from "react"
import { animated } from "@react-spring/web"
import * as styles from "./pageNight.module.scss"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { parseDate } from "@src/utils/data-parser"
import frameImg from "@images/png/15.png"
import Numbers from "@src/components/numbers"
import { imageCdnUrl } from "@src/utils/request"
import bgImg from "@images/2022/p8/30-100.jpg"
import iconFaceImg from "@images/2022/p8/31.png"
import iconCityImg from "@images/2022/p8/32.png"
import classnames from "@src/utils/classnames"

const PageNight = createPage(
  ({ offset, data }) => {
    const {
      "special-listening-radio": {
        attributes: { cover, title },
      },
      attributes: { "special-listening-at": listeningAt },
    } = data
    const parsedDate = parseDate(listeningAt, true)
    const anime1Styles = useEnteringTrail(3, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.4 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div>
          <div className={styles.radioContainer}>
            <div className={styles.radio}>
              <animated.img
                src={imageCdnUrl(cover, { w: 558, h: 558 })}
                style={anime1Styles[0]}
                alt={title}
              />
              <animated.img
                src={iconCityImg}
                style={anime1Styles[1]}
                className={styles.iconCity}
                alt="icon"
              />
              <animated.img
                src={iconFaceImg}
                style={anime1Styles[2]}
                className={styles.iconFace}
                alt="icon"
              />
            </div>
          </div>
        </div>

        <div>
          <animated.div style={anime2Styles[0]}>
            <b>{parsedDate.month}</b>月<b>{parsedDate.date}</b>日
            <b>凌晨{parsedDate.hour}点</b>
          </animated.div>
          <animated.div style={anime2Styles[1]}>
            {callYou(data)}还在听
            <br />
            <b>{title}</b>
          </animated.div>
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2022 年机核全年凌晨收听次数最多的节目：
          <br />
          《艾尔登法环》探秘Vol.1-交界地历史
        </animated.div>
      </>
    )
  },
  { className: classnames(styles.page, "pageLayout1") },
  { darkBg: true }
)

export const pageNightData = {
  key: "pageNight",
  bgImg,
  Page: PageNight,
  shouldHide: ({ "special-listening-radio": radio }) => {
    return !radio
  },
}

PageNight.displayName = "PageNight"
export default PageNight
